import { render, staticRenderFns } from "./OnDemandSession.vue?vue&type=template&id=db20a208&"
import script from "./OnDemandSession.vue?vue&type=script&lang=js&"
export * from "./OnDemandSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports